// @ vendors
const download = require('downloadjs');
const trim = require('lodash/string/trim');

// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireInformationActions = require('actions/hireInformation');
const { updateConsents } = require('actions/gdprConsents');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');

// @ utilities
const { formatText } = require('core/i18n').i18n;
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const DateHelper = require('utilities/dateHelper');
const { nonNumericFilter } = require('utilities/stringHelper');
const { getDebitCardHiringStatus } = require('utilities/hireCardsHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_SHORT_MONTH_SHORT_YEAR, SECOND_STEP } = require('constants/index');
const { E_CARD_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const { MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_ECARD_RESET,
  };
}

const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};

function setAccount(accountId) {
  return {
    type: actionTypes.HIRE_CARD_ECARD_SET_ACCOUNT,
    payload: {
      accountId,
    },
  };
}

function setAgreementCheckbox(evt) {
  return {
    type: actionTypes.HIRE_CARD_ECARD_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked: evt.target.checked,
    },
  };
}

function setVisibleStep(step) {
  return {
    type: actionTypes.HIRE_CARD_ECARD_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function validate(step, externalComponentsAreValid) {
  return {
    type: actionTypes.HIRE_CARD_ECARD_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
    },
  };
}

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardECard.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};
const validateBlockedAccount = () => (dispatch, getState) => {
  const accountsById = getState().accounts.get('byId');
  const contracto = accountsById.map(account => {
    return { numerodecontrato: account.get("newContractNumber"), producto: account.get("newProduct") }
  });
  const requestData = {
    query: {
      accounts: Object.values(contracto.toJS())
    }
  };
  return APIPost({
    dispatch,
    endpoint: 'validateBlockedAccount',
    params: requestData
  })
    .then(() => {
      return true
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(hireCardECardFailure(''));
        dispatch(validateLoading(false));
      } else {
        throw response;
      }
    });
}
const validateStep = step => (dispatch, getState) => {
  dispatch(validateBlockedAccount())
  if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
    const immCards = getState().cards;
    const immCardById = immCards && immCards.get('byId');
    const immCardByOrder = immCards && immCards.get('byOrder');

    const cardObj =
      immCardByOrder &&
      immCardByOrder.map(cardId => {
        const immCard = immCardById && immCardById.get(cardId);
        return {
          contractNumber: immCard.getIn(['contract', 'number']),
          pan: immCard.get('number'),
          product: immCard.get('newProduct'),
          subType: immCard.get('productSubType'),
          standard: immCard.getIn(['product', 'standard']),
        };
      });
    dispatch(validateLoading(true));
    return APIPost({
      dispatch,
      endpoint: 'validateCardHire',
      params: {
        query: { cards: cardObj },
      },
    })
      .then(() => {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      })
      .catch(error => {
        if (error) {
          if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
            dispatch(validate(step, true));
            dispatch(validateLoading(false));
          } else {
            dispatch(hireCardECardFailure(''));
            dispatch(validateLoading(false));
          }
        }
      });
  } else {
    dispatch(validateLoading(false));
    dispatch(validate(step, false));
  }
  return dispatch(getStep(step));
};

function setWillCancel(willCancel) {
  return {
    type: actionTypes.HIRE_CARD_ECARD_WILL_CANCEL,
    payload: {
      willCancel,
    },
  };
}

const hireCardECardRequest = () => ({
  type: actionTypes.HIRE_CARD_ECARD_REQUEST,
});

const hireCardECardSuccess = response => ({
  type: actionTypes.HIRE_CARD_ECARD_SUCCESS,
  payload: {
    response,
  },
});

const hireCardECardFailure = errorMsg => ({
  type: actionTypes.HIRE_CARD_ECARD_FAILURE,
  payload: {
    errorMsg,
  },
});

const setCardECard = (dispatch, data, termsAndsCondsHiringData) => {
  const requestData = {
    query: data,
  };

  dispatch(hireCardECardRequest());

  return APIPost({
    dispatch,
    endpoint: 'hireECard',
    params: requestData,
  })
    .then(response => {
      const status = getDebitCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardECardFailure(response.error));
      } else {
        dispatch(hireCardECardSuccess(response));
        dispatch(setTermsAndCondsInfo(E_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
      }
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(hireCardECardFailure(response.error));
      } else {
        throw response;
      }
    });
};

const hireCardECard = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardECard.getIn(['steps', SECOND_STEP, 'accountId']);
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);

    const data = {
      contratoTarjeta: {
        numerodecontrato: immAccount.get('contractNumber'),
        producto: immAccount.get('product'),
      },
      cuentaAsociada: {
        numerodecontrato: immAccount.get('contractNumber'),
        producto: immAccount.get('product'),
        nombreBeneficiario: selectedName,
      },
      dataToken,
    };

    const termsAndsCondsHiringData = [
      {
        passportProductId: E_CARD_PRODUCT_ALIAS.toUpperCase(),
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() => setCardECard(dispatch, data, termsAndsCondsHiringData))
      .catch(response => {
        if (!!response.error) {
          setCardECard(dispatch, data, termsAndsCondsHiringData);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

const generateEcardPDFRequest = () => ({
  type: actionTypes.HIRE_CARD_ECARD_GENERATE_PDF_REQUEST,
});

const generateEcardPDFFailure = response => ({
  type: actionTypes.HIRE_CARD_ECARD_GENERATE_PDF_FAILURE,
  payload: { response },
});

const generateEcardPDFSuccess = () => ({
  type: actionTypes.HIRE_CARD_ECARD_GENERATE_PDF_SUCCESS,
});

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_ECARD_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const generatePDF = (dispatch, params) => {
  const { pan, cvc, date, holder } = params;
  const requestParams = {
    header: {
      responseType: 'arraybuffer',
      accept: 'application/pdf',
    },
    query: {
      pan: nonNumericFilter(pan),
      cvc,
      fecha: date,
      titular: holder.replace(/\*/g, ' '),
    },
  };

  return APIGet({
    dispatch,
    endpoint: 'ecardPdf',
    params: requestParams,
  })
    .then(response => {
      const eCardPdfName = formatText('hireCardECard-pdfFileName') + '.pdf';
      dispatch(generateEcardPDFSuccess());
      download(response.xhr.response, eCardPdfName, 'application/pdf');
    })
    .catch(response => dispatch(generateEcardPDFFailure(response.error)));
};

function hireEcardGetTextReliefSuccess(response) {
  return {
    type: actionTypes.HIRE_CARD_ECARD_GET_TEXT_RELIEF_SUCCESS,
    payload: {
      response,
    },
  };
}

const downloadECard = () => (dispatch, getState) => {
  const immHireECardResponse = getState().hireCardECard.get('response');
  const pan = immHireECardResponse.get('cardNumber').replace(/ /g, '');
  const cvc = immHireECardResponse.getIn(['CVCCode', 'valueAttribute']);
  const date = DateHelper.formatDate(
    immHireECardResponse.get('expirationDate'),
    DATE_FORMAT_SHORT_MONTH_SHORT_YEAR
  );
  const holder = immHireECardResponse.get('textRelief');
  const contractNumber = immHireECardResponse.getIn(['cardContract', 'contractNumber']);
  const product = immHireECardResponse.getIn(['cardContract', 'product']);
  const params = {
    pan,
    cvc,
    date,
    contractNumber,
    product,
    holder,
  };

  dispatch(generateEcardPDFRequest());

  if (!!holder) {
    generatePDF(dispatch, params);
  } else {
    const requestData = {
      header: {
        version: 3,
      },
      query: {
        pan,
        numeroContrato: contractNumber,
        producto: product,
      },
    };
    return APIPost({
      dispatch,
      endpoint: 'cardInformation',
      params: requestData,
    })
      .then(response => {
        dispatch(hireEcardGetTextReliefSuccess(response));
        params.holder = trim(response.textoRelieve);
        generatePDF(dispatch, params);
      })
      .catch(response => {
        if (!!response.error) {
          dispatch(generateEcardPDFFailure(response.error));
        } else {
          throw response;
        }
      });
  }
};

module.exports = {
  downloadECard,
  hireCardECard,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setVisibleStep,
  setWillCancel,
  validateStep,
};
